import { render, staticRenderFns } from "./MarketingConsentForm.vue?vue&type=template&id=0dfc698b&scoped=true"
import script from "./MarketingConsentForm.vue?vue&type=script&lang=js"
export * from "./MarketingConsentForm.vue?vue&type=script&lang=js"
import style0 from "./MarketingConsentForm.vue?vue&type=style&index=0&id=0dfc698b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc698b",
  null
  
)

export default component.exports